export default __webpack_public_path__ + "static/media/a2.c61b7c03.jpg";